import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  
  private previousUrl: string = '';
  private currentUrl: string = '';

  constructor(private router: Router) {
    // Get the current URL on startup
    this.currentUrl = this.router.url;

    // Subscribe to router events
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      
      // When navigation ends, the *old* current URL becomes the new *previous* URL
      if (!this.currentUrl.includes('/payment') && !this.currentUrl.includes('/pricing')) this.previousUrl = this.currentUrl;

      // And the new *current* URL is the one from the event
      this.currentUrl = event.url;
    });
  }

  /**
   * Gets the URL the user was on before navigating to the *current* page.
   */
  public getPreviousUrl(): string {
    return this.previousUrl;
  }
}